<template>
  <!-- 企业类型 -->
  <div class="enterprise">
    <ul class="enterprise-box">
      <li
        class="enterprise-tab"
        :class="{'active':enterpriseType===1}"
        @click="onEnterpriseType(1)"
      >
        <h3 class="title">{{$t('crm_renter_item_enterprise.qi_ye_gong_shang_hu')}}</h3>
        <div class="arrow icon icon-jiantou"></div>
      </li>
      <li
        class="enterprise-tab"
        :class="{'active':enterpriseType===2}"
        @click="onEnterpriseType(2)"
      >
        <h3 class="title">{{$t('crm_renter_item_enterprise.ge_ti_gong_shang_hu')}}</h3>
        <div class="arrow icon icon-jiantou"></div>
      </li>
      <li
        class="enterprise-tab"
        :class="{'active':enterpriseType===3}"
        @click="onEnterpriseType(3)"
      >
        <h3 class="title">{{$t('crm_renter_item_enterprise.shi_ye_dan_wei')}}</h3>
        <div class="arrow icon icon-jiantou"></div>
      </li>
      <li
        class="enterprise-tab"
        :class="{'active':enterpriseType===4}"
        @click="onEnterpriseType(4)"
      >
        <h3 class="title">{{$t('crm_renter_item_enterprise.zjhdcs')}}</h3>
        <div class="arrow icon icon-jiantou"></div>
      </li>
      <li
        class="enterprise-tab"
        :class="{'active':enterpriseType===5}"
        @click="onEnterpriseType(5)"
      >
        <h3 class="title">{{$t('crm_renter_item_enterprise.ge_ren')}}</h3>
        <div class="arrow icon icon-jiantou"></div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    enterpriseType: {
      type: Number,
      default() {
        return 1;
      }
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.form.enterpriseType = val;
      }
    },
  },
  mounted() {
  },
  methods: {
    onEnterpriseType: function (num) {
      const enterpriseType = num || 1;
      // this.$emit('input', enterpriseType);
      this.$emit('change', enterpriseType);
      // this.$emit
    },


  },
};
</script>

<style lang="scss">

</style>
